import React, { useState, useEffect } from 'react';
import './Cards.css';
import CardItem from '../CardItem/CardItem';
import { Container, Typography, Box, Grid, Button } from '@mui/material'; // Button Added
import { Link } from 'react-router-dom'; // Link Added

const labels = {
  si: {
    heading: 'ඔබගේ ජීවින සහකරු මෙහි සොයා ගන්න !',
    findBride: 'ඔබගේ මනාලිය මෙහි සොයා ගන්න !',
    findGroom: 'ඔබගේ මනාලයා මෙහි සොයා ගන්න !',
    findPartner: 'ඔබගේ හොඳම ගැලපෙන සහකරු සොයා ගන්න',
    bestPlatform: 'ඔබගේ ජීවිත ගමන සඳහා හොඳම වේදිකාව මෙයයි',
    weddingPlans: 'හොඳම විවාහ සැලසුම්',
  },
  en: {
    heading: 'Find your life partner here!',
    findBride: 'Find your bride here!',
    findGroom: 'Find your groom here!',
    findPartner: 'Find your best matching partner',
    bestPlatform: 'This is the best platform for your life journey',
    weddingPlans: 'Best wedding plans',
  }
};

function Cards() {
  const [lang, setLang] = useState(() => localStorage.getItem('language') || 'si');

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'language' && e.newValue) setLang(e.newValue);
    };
    window.addEventListener('storage', onStorage);
    const interval = setInterval(() => {
      const currentLang = localStorage.getItem('language') || 'si';
      setLang(prevLang => prevLang !== currentLang ? currentLang : prevLang);
    }, 500);
    return () => {
      window.removeEventListener('storage', onStorage);
      clearInterval(interval);
    };
  }, []);

  const t = labels[lang] ?? labels.si;

  return (
    <div className='cards'>
      <h1>{t.heading}</h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              size='large'
              src='images/MBride.jpeg'
              text={t.findBride}
              title={t.findBride}
              icon='bride'
              path='/service-bride'
            />
            <CardItem
              size='large'
              src='images/MGroom.jpg'
              text={t.findGroom}
              title={t.findGroom}
              icon='groom'
              path='/service-groom'
            />
          </ul>
          {/* Info Cards Section */}
          <Box sx={{ mt: 8, mb: 4 }}>
            <Grid container spacing={4} justifyContent="center">
              {[
                { src: 'images/img3.jpg', text: t.findPartner, path: '/Infor-page' },
                { src: 'images/img4.jpg', text: t.bestPlatform, path: '/Infor-page' },
                { src: 'images/img5.jpg', text: t.weddingPlans, path: '/Infor-page' }
              ].map((card, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Box
                    component={Link} // Use Router Link here? Need to check imports
                    to={card.path}
                    sx={{
                      textDecoration: 'none',
                      display: 'block',
                      transition: 'transform 0.3s ease',
                      '&:hover': { transform: 'translateY(-8px)' }
                    }}
                  >
                    <Box
                      sx={{
                        overflow: 'hidden',
                        borderRadius: 4,
                        boxShadow: 3,
                        bgcolor: 'background.paper',
                        height: '100%',
                        position: 'relative'
                      }}
                    >
                      <Box
                        component="img"
                        src={card.src}
                        alt={card.text}
                        sx={{
                          width: '100%',
                          height: 280,
                          objectFit: 'cover',
                          display: 'block'
                        }}
                      />
                      <Box sx={{ p: 3, textAlign: 'center' }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
                          {card.text}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
          {/* <h1 style={{ paddingTop: '25px', paddingBottom: '9px' }}>අපගේ සාර්ථක විවාහ සම්බන්ධතා බලන්න !</h1> */}

        </div>
      </div>
    </div>
  );
}

export default Cards;
